var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { class: ["event", _vm.iseventlive], attrs: { fluid: "" } },
    [
      _c(
        "div",
        [
          _vm.iseventlive && _vm.liveEvent
            ? _c(
                "div",
                { class: ["scoreboard", _vm.liveEvent.IDFOSportType] },
                [
                  _vm.liveEvent
                    ? _c("live-event-info", { attrs: { event: _vm.liveEvent } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.idfomarket
            ? _c("headline-market", {
                attrs: {
                  idfomarket: _vm.idfomarket,
                  iseventlive: _vm.iseventlive,
                  liveevent: _vm.liveEvent,
                  ismatchstarted: _vm.ismatchstarted
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.idfomarket
            ? _c("div", { staticClass: "market" }, [
                _c("div", { staticClass: "market-unavailable" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Sports.NoAvailableMarkets")))
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe6cb7f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe6cb7f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/headlineEvent.vue
// module id = null
// module chunks = 